import { Button, Indicator } from '@mantine/core';
import { FC } from 'react';
import { Icon } from 'src/components/Icon';

import styles from './styles.module.css';

const hasNotification = true;

export const Notifications: FC = () => {
  return (
    <Button className={styles.button}>
      <Indicator disabled={!hasNotification} size={6} offset={4}>
        <Icon className={styles.icon} name="notifications" />
      </Indicator>
    </Button>
  );
};
